import { ColumnFiltersState, SortingState } from '@tanstack/react-table';
import { toSnakeCase } from './SnakeCase';

export const formatFilter = (filterState: ColumnFiltersState) => {
  return filterState.map((s) => `${toSnakeCase(s.id)}:${s.value}`).join(';');
};

export const columnFiltersToObject = (filterState: ColumnFiltersState) => {
  const filterObject: Record<string, string> = {};
  filterState.forEach((filter) => {
    if (filter.value) {
      filterObject[toSnakeCase(filter.id)] = String(filter.value);
    }
  });
  return filterObject;
};

export const formatSortState = (sort: SortingState) => {
  return sort.map((s) => `${toSnakeCase(s.id)}:${s.desc ? 'desc' : 'asc'}`).join(',');
};
